<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >

    <div>

      <b-modal
          id="modal-excel"
          centered
          title="دریافت اکسل ماهانه"
          ok-only
          ok-title="دریافت"
          @ok="downloadFile"
      >
        <b-form-group
            label="وضعیت پرداخت‌ها :"
            label-for="name-input"
        >
          <label>وضعیت پرداخت‌ها :</label>
          <v-select
              v-model="excelIsPayed"
              :options="perStatusOptions"
              :reduce="val => val.value"
              :clearable="false"
              class="per-page-selector d-inline-block w-75 mx-50"
          />
        </b-form-group>
        <b-form-group>
          <label>شروع تاریخ از :</label>
          <input
              type="text"
              id="excelFrom"
              :value="createJalaliDate(excelFrom)"
              class="form-control p-0 form-control-lg mx-auto block w-full rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
          />
          <custom-date-picker
              v-model="excelFrom"
              auto-submit
              format="YYYY-MM-DD"
              display-format="jYYYY/jMM/jDD"
              element="excelFrom"
              type="date"
              color="#5c6bc0"
              simple
              class="position-absolute p-0"
          ></custom-date-picker>
        </b-form-group>
        <b-form-group>
          <label>تا تاریخ :</label>
          <input
              type="text"
              id="excelTo"
              :value="createJalaliDate(excelTo)"
              class="form-control p-0 form-control-lg mx-auto block w-full rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
          />
          <custom-date-picker
              v-model="excelTo"
              auto-submit
              format="YYYY-MM-DD"
              display-format="jYYYY/jMM/jDD"
              element="excelTo"
              type="date"
              color="#5c6bc0"
              simple
              class="position-absolute p-0"
          ></custom-date-picker>
        </b-form-group>
      </b-modal>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Search -->
            <b-col
                cols="12"
                md="6"
                class="mt-1"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="debouncedSearch"
                    class="d-inline-block mr-1"
                    placeholder="جستجو کلی..."
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perStatus"
                  :options="perStatusOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
              <label>وضعیت پرداخت</label>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <b-button
                  variant="success"
                  class=""
                  v-b-modal.modal-excel
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              >
                دانلود اکسل لیست
              </b-button>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label class="mr-1">شروع تاریخ از : </label>
              <input
                  type="text"
                  id="startPaymentDate"
                  :value="createJalaliDate(startPaymentDate)"
                  class="form-control p-0 form-control-lg mx-auto block w-50 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              />
              <custom-date-picker
                  v-model="startPaymentDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  class=""
                  element="startPaymentDate"
                  type="date"
                  color="#5c6bc0"
                  simple
                  class="position-absolute p-0"
              ></custom-date-picker>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label class="mr-1">تا : </label>
              <input
                  type="text"
                  id="endPaymentDate"
                  :value="createJalaliDate(endPaymentDate)"
                  class="form-control p-0 form-control-lg mx-auto block w-50 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              />
              <custom-date-picker
                  v-model="endPaymentDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  class=""
                  element="endPaymentDate"
                  type="date"
                  color="#5c6bc0"
                  simple
                  class="position-absolute p-0"
              ></custom-date-picker>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <b-button
                  variant="warning"
                  @click="searchWithDate"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              >
                جستجو با تاریخ
              </b-button>
            </b-col>

            <b-col
                cols="12"
                md="3"
            >
              <div class="d-flex align-items-center justify-content-end pt-2">
                <b-form-input
                    type="number"
                    v-model="filterPrice"
                    class="d-inline-block mr-1"
                    placeholder="جستجو بر اساس قیمت نهایی..."
                />
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="payments"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >

          <template #cell(userName)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :variant="`success`"
                    :to="{ name: 'apps-users-edit', params: { id: data.item.userId } }"
                />
              </template>
              <b-link
                  :to="{ name: 'apps-users-edit', params: { id: data.item.userId } }"
                  class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.userFullName }}
              </b-link>
              <small class="text-muted">@{{ data.item.userId }}</small>
            </b-media>
          </template>

          <!-- Column: product -->
          <template #cell(product)="data">
            <span v-if="data.item.isWalletCharge === true" class="text-success">
                افزایش اعتبار
            </span>
            <span v-if="data.item.isTicket === true" class="">
                بلیط سمینار
            </span>
            <span v-if="data.item.productTitle !== null">
              {{ data.item.productTitle }}
            </span>
          </template>

          <!-- Column: Status -->
          <template #cell(isPayed)="data">
            <b-badge
                v-if="data.item.isPayed"
                pill
                class="text-capitalize"
                :variant="`success`"
            >
              پرداخت موفق
            </b-badge>
            <b-badge
                v-else-if="!data.item.isPayed"
                pill
                class="text-capitalize"
                :variant="`danger`"
            >
              پرداخت ناموفق
            </b-badge>
          </template>

          <!-- Column: amount -->
          <template #cell(amount)="data">
            <span class="text-primary">
               {{ makePrettyPrice(data.item.amount) }} تومان
            </span>
          </template>

          <template #cell(cardHolderPan)="data">
            <span class="text-warning" dir="ltr">
               {{ data.item.cardHolderPan }}
            </span>
          </template>

          <!-- Column: createDate -->
          <template #cell(paymentDate)="data">
            <span>
              {{ data.item.paymentDate.slice(11, 16) }}
              -
              {{ createJalaliDate(data.item.paymentDate.slice(0, 10)) }}
            </span>
          </template>

          <!-- Column: chat -->
          <template #cell(chat)="data">
            <b-link :to="{ name: 'apps-chats-id', params: { id: data.item.userId } }">
              <feather-icon icon="MessageCircleIcon" size="20"/>
            </b-link>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCounts"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {PaymentGetAllRequest, PaymentGetPaymentsRequest} from "@/libs/Api/Payment";
import Helper from "@/libs/Helper";
import {getUserData} from "@/auth/utils";
import axiosIns from "@/libs/axios";
import {saveAs} from 'file-saver';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  title: "لیست پرداخت ها - پنل ادمین نهایی شو",
  name: "PaymentsList",
  data() {
    return {
      payments: null,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      overlay: false,
      perPageOptions: [10, 20, 30, 40, 50],
      perState: '',
      perStatus: '',
      timeOut: null,
      startPaymentDate: '',
      endPaymentDate: '',
      filterPrice:'',
      perStateOptions: [
        {label: 'همه', value: ''},
        {label: 'وارد شده', value: 1},
        {label: 'فالو نکرده', value: 2},
        {label: 'آیدی اشتباه', value: 3}
      ],
      perStatusOptions: [
        {label: 'همه', value: ''},
        {label: 'پرداخت موفق', value: true},
        {label: 'پرداخت ناموفق', value: false},
      ],
      myTableColumns: [
        {key: 'userName', label: 'اطلاعات کاربر'},
        {key: 'orderId', label: 'شناسه سفارش'},
        {key: 'product', label: 'محصول'},
        {key: 'paymentDate', label: 'تاریخ ثبت'},
        {key: 'nationalId', label: 'کد ملی'},
        {key: 'mobile', label: 'موبایل'},
        {key: 'paymentId', label: 'شناسه پرداخت'},
        {key: 'isPayed', label: 'وضعیت پرداخت'},
        {key: 'amount', label: 'مقدار پرداخت'},
        {key: 'paymentRef', label: 'کد پرداخت'},
        {key: 'cardHolderPan', label: 'شماره کارت'},
        // {key: 'chat', label: 'چت'},
        // { key: 'actions',label:'عملیات'},
      ],
      searchQuery: '',
      excelIsPayed:'',
      excelFrom:'',
      excelTo:'',
    }
  },
  async created() {
    await this.getPayments(this.perPage, this.currentPage, this.searchQuery, this.perState, this.perStatus , this.filterPrice)
  },
  methods: {
    refreshData() {
      this.getPayments(this.perPage, this.currentPage, this.searchQuery)
    },
    async getPayments(count , pageNumber, searchCommand , state , status , filterPrice) {
      let _this = this;
      _this.overlay = true;
      let data = {
        page: pageNumber,
        size: count,
        search: searchCommand,
        state: state,
        isPayed: status,
        startPaymentDate: this.startPaymentDate,
        endPaymentDate: this.endPaymentDate,
        filterPrice:filterPrice
      }

      let paymentGetAllRequest = new PaymentGetPaymentsRequest(_this);
      paymentGetAllRequest.setParams(data);
      await paymentGetAllRequest.fetch(function (content) {
        _this.overlay = false;
        _this.payments = content.data;
        _this.totalCounts = content.totalCount;
      }, function (error) {
        _this.overlay = false;
        console.log(error);
      })
    },
    async downloadFile() {
      let _this = this;
      if (_this.excelFrom === '' || _this.excelTo === ''){
        return _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CheckIcon',
            variant: 'danger',
            text: `تمامی فیلد‌ها الزامی میباشند.`,
          },
        })
      }
      _this.overlay = true;
      let userToken = getUserData().token;

      await axiosIns.post(`Payment/GetExcel`, null, {
        params:{
          isPayed:this.excelIsPayed,
          from:this.excelFrom,
          to:this.excelTo
        },
        responseType: 'blob',
        'Authorization': userToken,
        'Token': userToken,
      }).then(resp => {
        _this.overlay = false;
        saveAs(resp.data, 'لیست.xlsx');
      })
          .catch((error) => {
            _this.overlay = false;
            console.log(error);
          });
    },
    createJalaliDate(param) {
      if (param !== null && param !== '') {
        return new Date(param).toLocaleDateString("fa-IR",);
      }
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    async searchWithDate(){
      await this.getPayments(this.perPage, this.currentPage, this.searchQuery, this.perState, this.perStatus ,this.filterPrice)
    }
  },
  watch: {
    perPage: function (nv, ov) {
      this.getPayments(nv, this.currentPage, this.searchQuery, this.perState, this.perStatus,this.filterPrice);
    },
    currentPage: function (nv, ov) {
      this.getPayments(this.perPage, nv, this.searchQuery, this.perState, this.perStatus,this.filterPrice);
    },
    searchQuery: function (nv, ov) {
      this.getPayments(this.perPage, this.currentPage, nv, this.perState, this.perStatus,this.filterPrice)
    },
    perState: function (nv, ov) {
      this.getPayments(this.perPage, this.currentPage, this.searchQuery, nv, this.perStatus,this.filterPrice)
    },
    perStatus: function (nv, ov) {
      this.getPayments(this.perPage, this.currentPage, this.searchQuery, this.perState, nv,this.filterPrice)
    },
    filterPrice(nv,ov){
      this.getPayments(this.perPage, this.currentPage, this.searchQuery, this.perState, this.perStatus , nv)
    }
  },
  computed: {
    debouncedSearch: {
      get() {
        return this.searchQuery
      },
      set(val) {
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.timeOut = setTimeout(() => {
          this.searchQuery = val
        }, 600)
      }
    }
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    BOverlay,
    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
